import _ from 'lodash';
import {getCachedFingerprintV2, getCachedFingerprintV1} from '../fingerprint/FingerprintUtils';
import cache from '../common/cache';

const ISP_REDIRECT_CACHE_KEY_PREFIX = 'VUP_ISP_REDIRECT_INFO';
const GEO_REDIRECT_CACHE_KEY_PREFIX = 'VUP_GEO_REDIRECT_INFO';
const FINGERPRINT_REDIRECT_CACHE_KEY = 'VUP_FINGERPRINT_REDIRECT_INFO';

export const CACHE_EXPIRY_MS = 60 * 60 * 1000;

export default class CardRedirection {
  constructor(renderers, CardApi, CampaignApi, RedirectPreferenceApi) {
    this.CardApi = CardApi;
    this.CampaignApi = CampaignApi;
    this.RedirectPreferenceApi = RedirectPreferenceApi;

    this.cardIspRedirection = _(renderers)
      .map(r => ({
          cardId: r.cardId,
          redirectInfo: null
        })
      ).uniqBy('cardId').value();

    this.campaignGeoRedirection = _(renderers)
      .map(r => ({
          campaignId: r.campaignId,
          redirectInfo: null
        })
      ).uniqBy('campaignId').value();

    this.cardQuotaRedirection = _(renderers)
      .map(r => ({
          cardId: r.cardId,
          redirectInfo: null
        })
      ).uniqBy('cardId').value();

    this.fingerprintRedirectPreference = null;
  }

  async getCardIspRedirectInfo(cardId) {
    if (!cardId) {
      return null;
    }

    const cardInfo = _.find(this.cardIspRedirection, {cardId});
    if (!cardInfo) {
      return null;
    }

    const cachedInfo = this.getIspRedirectInfoFromCache(cardId);
    if (cachedInfo && cachedInfo.redirectInfo) {
      return cardInfo.redirectInfo;
    }

    try {
      if (!cardInfo.redirectInfo) {
        cardInfo.redirectInfo = await this.CardApi.checkIspRedirect(cardId)
          .catch(() => null);
      }
      this.setIspRedirectInfoInCache(cardId, cardInfo);
      return cardInfo.redirectInfo;
    } catch (e) {
      return null;
    }
  }

  getIspRedirectInfoFromCache(cardId) {
    return cache.get(`${ISP_REDIRECT_CACHE_KEY_PREFIX}_${cardId}`);
  }

  setIspRedirectInfoInCache(cardId, res) {
    cache.set(`${ISP_REDIRECT_CACHE_KEY_PREFIX}_${cardId}`, res, new Date().getTime() + CACHE_EXPIRY_MS);
  }

  async getCardQuotaRedirectInfo(cardId) {
    if (!cardId) {
      return null;
    }

    const cardInfo = _.find(this.cardQuotaRedirection, {cardId});
    if (!cardInfo) {
      return null;
    }

    try {
      if (!cardInfo.redirectInfo) {
        cardInfo.redirectInfo = await this.CardApi.checkQuotaRedirect(cardId)
          .catch(() => null);
      }
      return cardInfo.redirectInfo;
    } catch (e) {
      return null;
    }
  }

  async getCampaignGeoRedirectInfo(campaignId) {
    if (!campaignId) {
      return null;
    }

    const campaignInfo = _.find(this.campaignGeoRedirection, {campaignId});
    if (!campaignInfo) {
      return null;
    }

    const cachedInfo = this.getGeoRedirectInfoFromCache(campaignId);
    if (cachedInfo && cachedInfo.redirectInfo) {
      return campaignInfo.redirectInfo;
    }

    try {
      if (!campaignInfo.redirectInfo) {
        campaignInfo.redirectInfo = await this.CampaignApi.checkGeoRedirect(campaignId)
          .catch(() => null);
      }
      this.setGeoRedirectInfoInCache(campaignId, campaignInfo);
      return campaignInfo.redirectInfo;
    } catch (e) {
      return null;
    }
  }

  getGeoRedirectInfoFromCache(cardId) {
    return cache.get(`${GEO_REDIRECT_CACHE_KEY_PREFIX}_${cardId}`);
  }

  setGeoRedirectInfoInCache(cardId, res) {
    cache.set(`${GEO_REDIRECT_CACHE_KEY_PREFIX}_${cardId}`, res, new Date().getTime() + CACHE_EXPIRY_MS);
  }

  async getFingerprintRedirectInfo() {
    try {
      if (this.fingerprintRedirectPreference) {
        return this.fingerprintRedirectPreference;
      }

      const cachedInfo = this.getFingerprintRedirectInfoFromCache();
      if (cachedInfo) {
        return cachedInfo;
      }

      const fingerprint = getCachedFingerprintV2();

      const fingerprintOld = getCachedFingerprintV1();
      if (!fingerprint) {
        return null;
      }
      this.fingerprintRedirectPreference = await this.RedirectPreferenceApi.get(fingerprint, fingerprintOld)
          .catch(() => null);
      this.setFingerprintRedirectInfoInCache(this.fingerprintRedirectPreference);
      return this.fingerprintRedirectPreference;
    } catch (e) {
      return null;
    }
  }

  getFingerprintRedirectInfoFromCache() {
    return cache.get(FINGERPRINT_REDIRECT_CACHE_KEY);
  }

  setFingerprintRedirectInfoInCache(res) {
    cache.set(FINGERPRINT_REDIRECT_CACHE_KEY, res, new Date().getTime() + CACHE_EXPIRY_MS);
  }
}
